import DashboardLayout from "../../layout";

const Profile = () => {
  return <DashboardLayout>Profile</DashboardLayout>;
};

export default Profile;
